import { render } from "./ElLogo.vue?vue&type=template&id=67470295&scoped=true&lang=html"
import script from "./ElLogo.vue?vue&type=script&lang=js"
export * from "./ElLogo.vue?vue&type=script&lang=js"

import "./ElLogo.vue?vue&type=style&index=0&id=67470295&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67470295"]])

export default __exports__